var App = App || {};

App.SectionTabs = (function ($) {
    'use strict';

    function Init() {
        const selector = $(".section.section-tabs");

        if (selector.length) {

            selector.each(function () {
                const section = $(this);
                const select = section.find(".form-select");

                App.Base.SwipeInit(section);

                select.on("change", function () {
                    const activeTab = section.find(`[data-bs-target=\"${$(this).val()}\"]`);
                    activeTab.tab("show");
                });

                section.on("shown.bs.tab", function (e) {
                    const activeTab = section.find("[data-bs-toggle=\"tab\"].active").attr("data-bs-target");
                    select.val(activeTab);
                });
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.SectionTabs.Init();
}); 